<template>
  <v-container class="px-0">
    <btn-add-material-pers v-model="mostrarAddMaterial" :material-edit="materialEdit" @actualizado="actualizadoMaterial"
                           @cerrado="cerrarFormularioMaterial"/>
    <v-row no-gutters>
      <v-col cols="12">
        <v-toolbar color="transparent primary--text" flat>
          <v-toolbar-title class="font-weight-bold">
            {{ $tc('listado_materiales') | capitalize }}
          </v-toolbar-title>
          <v-spacer/>
          <template>
            <v-btn icon color="primary" :disabled="materiales.cargando" @click="cargarMateriales()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col>
        <filtro-nombre-material @actualizado="filtroNombreActualizado"/>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col>
        <div class="mt-4">
          <filtro-menu-material v-model="filtros" @actualizado="cargarMateriales"/>
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="pt-4">
      <v-col :cols="esMovil ? 12 : 3" class="pa-2">
        <v-card outlined height="200" @click="crearMaterial()">
          <v-card-title class="primary--text body-2 text-capitalize">
            {{ $t("crear") }}
          </v-card-title>
          <v-card-subtitle class="text-uppercase primary--text subtitle-1">
            {{ $t("nuevo_material") }}
          </v-card-subtitle>
          <v-card-text>&nbsp;</v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-icon color="primary" size="4.0rem">mdi-plus-circle</v-icon>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col :cols="esMovil ? 12 : 3" v-for="k in (materiales.cargando ? 4 : 0)" :key="k" class="pa-2">
        <v-skeleton-loader ref="skeleton" type="image" class="mx-auto"/>
      </v-col>

      <v-col :cols="esMovil ? 12 : 3" v-for="(material,index) in (!materiales.cargando ? materiales.listado : [])"
             :key="index" class="pa-2">
        <modal-ver-material v-model="mostrarInfoMaterial" :material="materialSeleccionado"
                            @cerrado="mostrarInfoMaterial = false"/>
        <v-card outlined @click.prevent="verMaterial(material)" hover>
          <div class="pa-4">
            <v-img height="130" :src="material.imagen" contain position="right" content-class="py-5">
              <v-card-title class="primary--text body-2 pt-0">
                {{ material.marca }}
              </v-card-title>
              <v-card-subtitle class="primary--text subtitle-1">
                <descripcion-mat-pers-cmp :material="material"/>
              </v-card-subtitle>
              <v-card-text class="pa-0">&nbsp;</v-card-text>
            </v-img>
          </div>
          <v-card-actions class="pa-0">
            <btn-publicar-material v-if="usuario && usuario.tipo.codigo !== 'no-profesional' && !material.publico"
                                   @solicitada="material.solicitadaPublicacion = true" :material="material"/>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn icon v-if="usuario && usuario.tipo.codigo !== 'no-profesional' && material.publico"
                       @click.stop="despublicarMaterial(material)" v-on="on">
                  <v-icon color="secondary">mdi-lock-open</v-icon>
                </v-btn>
              </template>
              <span class="text-capitalize">{{ $t("despublicar") }}</span>
            </v-tooltip>
            <v-spacer/>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn icon color="primary" @click.stop="editarMaterial(material)" v-on="on">
                  <v-icon>mdi-square-edit-outline</v-icon>
                </v-btn>
              </template>
              <span class="text-capitalize">{{ $t("editar") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn icon @click.stop="duplicarMaterial(material)" v-on="on">
                  <v-icon color="primary">mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span class="text-capitalize">{{ $t("duplicar") }}</span>
            </v-tooltip>
            <btn-compartir :id="material.id" :titulo="$t('compartir_titulo')"
                           :descripcion="$t('compartir_descripcion')" :peticion-compartir="peticionCompartir"/>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn icon @click.stop="borrarMaterial(material)" v-on="on">
                  <v-icon color="primary">mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span class="text-capitalize">{{ $t("borrar") }}</span>
            </v-tooltip>
          </v-card-actions>

        </v-card>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <div class="text-center">
          <v-pagination circle v-model="materiales.pagina" :length="materiales.paginas"
                        :disabled="materiales.cargando"/>
        </div>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";
import ImagenesServicio from "@/comunes/servicios/ImagenesServicio";
import BtnAddMaterialPers from "./componentes/BtnAddMaterial/BtnAddMaterialPers";
import DescripcionesServicio from "@/comunes/servicios/DescripcionesServicio";
import BtnPublicarMaterial from "@/paginas/material-guardado/componentes/BtnPublicarMaterial";
import {MOSTRAR_DIALOGO_CONFIRMACION, MOSTRAR_SNACKBAR} from "@/store/store-app";
import BtnCompartir from "@/components/BtnCompartir";
import FiltroNombreMaterial from "@/components/FiltroNombreMaterial";
import FiltroMenuMaterial from "@/components/FiltroMenuMaterial";
import ModalVerMaterial from "@/components/ModalVerMaterial";
import {mapState} from "vuex";
import DescripcionMatPersCmp from "@/components/DescripcionMatPersCmp";

export default {
  name: 'ProyectoListadoPagina',
  components: {
    DescripcionMatPersCmp,
    BtnAddMaterialPers,
    BtnPublicarMaterial,
    BtnCompartir,
    FiltroNombreMaterial,
    FiltroMenuMaterial,
    ModalVerMaterial
  },
  data: () => ({
    materiales: {
      listado: [],
      cargando: false,
      pagina: 1,
      porPagina: 15,
      paginas: 0
    },
    busqueda: "",
    menu: false,
    filtros: [],
    mostrarAddMaterial: false,
    mostrarInfoMaterial: false,
    materialSeleccionado: {},
    materialEdit: null
  }),
  computed: {
    esMovil() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    ...mapState(["usuario"]),
  },
  mounted() {
    this.cargarMateriales();
  },
  watch: {
    'materiales.pagina': function () {
      this.cargarMateriales();
    },
    busqueda() {
      this.cargarMateriales();
    }
  },
  methods: {
    filtroNombreActualizado(val) {
      this.busqueda = val
      this.cargarMateriales()
    },
    calcularMaterialImgSrc(solCons, material) {
      return ImagenesServicio.imgMaterial(solCons.codigo, material.referencia);
    },
    descripcionTipSolCons(tipSolCons) {
      return DescripcionesServicio.descripcionTipoSolCons(tipSolCons);
    },
    goTo(path) {
      VueRouteHelper.goTo(path, this.$router);
    },
    cargarMateriales() {
      if (this.materiales.cargando) return;

      this.materiales.cargando = true;
      let params = {
        pagina: this.materiales.pagina - 1,
        porPagina: this.materiales.porPagina,
      };

      if (this.busqueda && this.busqueda.length > 0) params.busqueda = this.busqueda;

      this.filtros.forEach((fil) => {
        if (fil.model.length > 0)
          params[fil.nombre] = fil.model.join(",");
      });

      HttpHelper.get('material-personalizado/listado', params)
          .then((res) => {
            this.materiales.listado = res.content;
            this.materiales.paginas = res.totalPages;
          })
          .finally(() => {
            this.materiales.cargando = false;
          });
    },
    actualizadoMaterial() {
      this.mostrarAddMaterial = false;
      this.materialEdit = null
      this.cargarMateriales();
    },
    cerrarFormularioMaterial() {
      this.mostrarAddMaterial = false;
      this.materialEdit = null
    },
    crearMaterial() {
      this.mostrarAddMaterial = true;
    },
    verMaterial(material) {
      this.materialSeleccionado = material
      this.mostrarInfoMaterial = true
    },
    editarMaterial(material) {
      this.materialEdit = material
      this.mostrarAddMaterial = true
    },
    duplicarMaterial(material) {
      this.$store.dispatch(MOSTRAR_DIALOGO_CONFIRMACION, {
        titulo: this.$t('duplicar'),
        color: "info",
        texto: this.$t('preg_duplicar', {material: material.marca + ' - ' + material.coleccion})
      }).then(() => {
        HttpHelper.get(`material-personalizado/${material.id}/duplicar`)
            .then(() => {
              this.$store.commit(MOSTRAR_SNACKBAR, {texto: this.$t('mat_duplicado'), color: "success"});
              this.cargarMateriales();
            });
      });
    },
    borrarMaterial(material) {
      this.$store.dispatch(MOSTRAR_DIALOGO_CONFIRMACION, {
        titulo: this.$t('borrar'),
        color: "warning",
        texto: this.$t('preg_borrar', {material: material.marca + ' - ' + material.coleccion})
      }).then(() => {
        HttpHelper.get(`material-personalizado/${material.id}/borrar`)
            .then(() => {
              this.$store.commit(MOSTRAR_SNACKBAR, {texto: this.$t('mat_borrado'), color: "success"});
              this.cargarMateriales();
            })
            .catch((error) => {
              const msg = error && Object.prototype.hasOwnProperty.call(error, 'mensaje')
                  ? error.mensaje : this.$t('error_borrar');
              this.$store.commit(MOSTRAR_SNACKBAR, {
                texto: msg,
                color: "error"
              });
            })
      });
    },
    peticionCompartir(id) {
      return new Promise((resolve, reject) => {
        HttpHelper.get(`material-personalizado/${id}/compartir`)
            .then((response) => {
              resolve({url: `#/material-detalles/${id}?clave-compartir=${response.clave}`});
            })
            .catch(() => {
              reject();
            })
      });
    },
    despublicarMaterial(material) {
      this.$store.dispatch(MOSTRAR_DIALOGO_CONFIRMACION, {
        titulo: this.$t('despublicar'),
        color: "warning",
        texto: this.$t('preg_despublicar', {material: material.marca + ' - ' + material.coleccion})
      }).then(() => {
        HttpHelper.get(`material-personalizado/${material.id}/despublicar`).then(() => {
          this.$store.commit(MOSTRAR_SNACKBAR, {texto: this.$t('mat_despublicado'), color: "success"});
          this.cargarMateriales();
        })
      });
    }
  }
};
</script>

<style lang="scss">
.contenedor-principal {
  padding: 0;
}

.v-pagination {
  button {
    box-shadow: none !important;
  }
}
</style>

<style scoped lang="scss">
.v-alert.info {
  background-color: #f7d9cd !important;
  color: #40108e !important;

  .v-icon, .v-icon::before {
    color: #40108e !important;
    font-size: 30px !important;
    margin-top: 5px !important;
  }
}
</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "nuevo_material": "nuevo material",
    "listado_materiales": "Materiales creados",
    "sin_materiales": "No tienes ningún material creado, para crear un nuevo material pulsando el botón: ",
    "material_actualizado": "Material actualizado correctamente",
    "material_borrado": "Material borrado correctamente",
    "preg_borrar": "¿Estás seguro de que quieres borrar el material <span class='font-weight-bold'>{material}</span>?",
    "duplicar": "duplicar",
    "preg_duplicar": "¿Quieres duplicar el material <span class='font-weight-bold'>{material}</span>?",
    "compartir_titulo": "Compartir material",
    "compartir_descripcion": "Cualquier persona con este enlace puede visualizar los detalles de este material",
    "mat_borrado": "El material ha sido borrado",
    "mat_duplicado": "Se ha creado una copia del material",
    "uso": "Uso",
    "absorcion_agua": "Absorción agua",
    "visibilidad": "Visibilidad",
    "despublicar": "Despublicar",
    "preg_despublicar": "¿Estás seguro de que quieres despublicar el material <span class='font-weight-bold'>{material}</span>?",
    "mat_despublicado": "El material ha sido despublicado",
    "error_borrar": "No se ha podido borrar el material"
  }
}
</i18n>
<!--@formatter:oon-->
